// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-popover.popCustomZ.el-popover--plain{padding:16px 10px;line-height:20px;background-color:#283c79;color:#fff}.el-popover.popCustomZ.el-popover--plain .popper__arrow:after{border-top-color:#283c79}.el-popover.popCustomZT{min-width:10px!important;padding:10px;background-color:#283c79;color:#fff}.el-popover.popCustomZT .popper__arrow:after{border-top-color:#283c79}", ""]);
// Exports
module.exports = exports;
